import styled from 'styled-components';
import StopVehicle from './component';

export default styled(StopVehicle)`
  background-color: var(--grey800);
  height: 36px;
  color: #fff;
  display: flex;
  align-items: center;
  .extras {
    display: flex;
  }
  .extra {
    width: 26px;
    margin-right: 8px;
    &:last-child {
      margin-right: 0;
    }
  }
  .cell {
    padding: 0 8px;
    margin-right: 8px;
    &__smallpadding {
      padding: 0 8px;
    }
    &__right {
      text-align: right;
    }
    &__light {
      color: var(--grey500);
    }
  }
`;
